import { computed, inject } from 'vue-demi';
import { D as DATE_FORMAT, L as LOCALE, T as TIME_FORMAT } from './TIME_FORMAT-3d8aa6be.js';
import { D as DateFormat, T as TimeFormat } from './TimeFormat-a7f5565b.js';

const useDateFormat = format => {
  return computed(() => {
    var _a;
    return (_a = format.value) !== null && _a !== void 0 ? _a : inject(DATE_FORMAT, DateFormat.Short);
  });
};

const useLocale = locale => {
  return computed(() => {
    var _a;
    return (_a = locale.value) !== null && _a !== void 0 ? _a : inject(LOCALE, navigator.language);
  });
};

const useTimeFormat = format => {
  return computed(() => {
    var _a;
    return (_a = format.value) !== null && _a !== void 0 ? _a : inject(TIME_FORMAT, TimeFormat.Auto);
  });
};

export { useLocale as a, useTimeFormat as b, useDateFormat as u };
